var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-echarts",style:({width: _vm.width, height: _vm.height, margin: '0 auto'}),attrs:{"id":_vm.id},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }